import { Component, Input } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { LectureService } from '../shared/lecture.service';

@Component({
  selector: 'app-lecture-public-button',
  templateUrl: './lecture-public-button.component.html'
})
export class LecturePublicButtonComponent {
  @Input() lecture: Lecture;

  constructor(private snackBar: MatSnackBar, private lectureService: LectureService) { }

  onChange(value: boolean, event) {
    if (this.lecture.public !== value) {
      const changedLecture: Lecture = Object.assign(new Lecture(), this.lecture);
      changedLecture.changePublic(value);
      this.onSubmit(changedLecture);
    }
  }

  async onSubmit(changedLecture: Lecture) {
    delete changedLecture.ownerObservable;
    try {
      this.lectureService.update(this.lecture.$key, changedLecture);
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-public-button/lecture-public-button.component.ts